import Keycloak from 'keycloak-js';
import { keycloakOptions } from '../config';
import axios from 'axios';

const keycloak = Keycloak(keycloakOptions);

export function integrateUsingKeycloakToken() {
    axios.interceptors.request.use(async config => {
        await keycloak.updateToken(30)
            .error(function() {
                window.location.reload();
            })
            .success(function(refreshed) {
                if (refreshed) {
                    const bearer = 'Bearer ' + keycloak.token;
                    axios.defaults.headers.common['Authorization'] = bearer;
                    config.headers.common['Authorization'] = bearer;
                }
            });
        return config;
    }, function (error) {
        // Do something with request error
        return Promise.reject(error);
    });
}

export default keycloak;



// WEBPACK FOOTER //
// ./src/helpers/keycloak.js